/**
 * Converts a string to Title Case (first letter uppercase, rest lowercase)
 * @param {string} str - The string to convert
 * @returns {string} The Title Cased string
 */
export const toTitleCase = (str) => {
  if (!str || typeof str !== 'string') return str;
  
  // Trim whitespace and convert to title case
  const trimmed = str.trim();
  if (trimmed.length === 0) return trimmed;
  
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
};
